<script lang="ts">
    export let active: "scenarios" | "matrices" | "publish" = "scenarios";
</script>

<div class="card card-bleed border-bottom border-bottom-md-0 shadow-light-lg">
    <div class="collapse d-md-block" id="sidenavCollapse">
        <div class="card-body">
            <h6 class="fw-bold text-uppercase mb-3">Project</h6>

            <ul class="card-list list text-gray-700 mb-6">
                <li class="list-item {active === "scenarios" ? "active" : ""}">
                    <div role="button" class="list-link text-reset" on:click={() => active = "scenarios"} on:keypress={() => active = "scenarios"}>Scenarios</div>
                </li>
                <!-- <li class="list-item {active === "matrices" ? "active" : ""}">
                    <div role="button" class="list-link text-reset" on:click={() => active = "matrices"} on:keypress={() => active = "matrices"}>OD-Matrices</div>
                </li> -->
                <li class="list-item {active === "publish" ? "active" : ""}">
                    <div role="button" class="list-link text-reset" on:click={() => active = "publish"} on:keypress={() => active = "publish"}>Route planners</div>
                </li>
            </ul>
        </div>
    </div>
</div>
